<template>
    <div class="tw-p-3 tw-mt-6 card tw-w-fit tw-mx-auto">
        <div v-if="!isConnected">
            <div class="d-flex mt-2">
                <div class="h3 mr-auto">Connect with Xero</div>
                <div class="pt-1">
                    <img src="@/images/brands/xero_blue.png" class="icon-lg" alt="Xero Logo" />
                </div>
            </div>

            <Submenu
                class="mb-1 [@media(max-width:900px)]:tw-flex-row tw-flex-col !tw-text-eventwise-800"
                :pages="selectableTenants"
                value-key="tenantId"
                @update:model-value="(v) => setSelected(v)"
            >
                <template #header>
                    <p v-if="reconnectingTenantId" class="mb-4">
                        Please select the organisation you are reconnecting to continue:
                    </p>
                    <p v-else class="mb-4">
                        You have previously connected to Xero with Eventwise
                        <br />
                        Please select which organisation you would like to connect:
                    </p>
                </template>
                <template #default="{ page }">
                    <span v-if="!reconnectingTenantId && isAlreadyConnected(page)">
                        <i class="mdi mdi-alert"></i>
                        {{ page.tenantName }}
                        <Tag type="warning">Already Connected</Tag>
                    </span>
                    <span v-else>{{ page.tenantName }}</span>
                </template>
            </Submenu>
            <Button
                type="is-success"
                :disabled="selectedItem === null"
                :loading="connecting"
                class="tw-w-full"
                @click="processSelection()"
            >
                Complete Connection
            </Button>
        </div>
        <div v-else>
            <div class="d-flex my-2">
                <div class="h3 mr-auto">Connected to Xero</div>
                <div class="pt-1">
                    <img src="@/images/brands/xero_blue.png" class="icon-lg" alt="Xero Logo" />
                </div>
            </div>
            <Banner type="is-success" has-icon :closable="false">
                You have successfully connected your Xero organisation.
            </Banner>
            <FormField class="my-2" style="text-align: center">
                <a :href="redirectTo">Go back</a>
            </FormField>
        </div>
    </div>
    <Toast />
</template>
<script>
import Button from '@/js/components/controls/Button.vue';
import Submenu from '@/js/components/controls/Submenu.vue';
import FormField from '@/js/components/widgets/FormField.vue';
import Banner from '@/js/components/Layout/Banner.vue';
import Tag from '@/js/components/Tag.vue';
import Toast from '@/js/components/Toast.vue';

export default {
    components: {
        Submenu,
        Button,
        FormField,
        Banner,
        Tag,
        Toast,
    },
    props: {
        redirectTo: {
            type: String,
            default: () => window.redirectTo ?? '',
        },
        alreadyConnected: {
            type: Array,
            default: () => window.alreadyConnected ?? [],
        },
        xeroTenants: {
            type: Array,
            default: () => window.xeroTenants ?? [],
        },
        reconnectingTenantId: {
            type: String,
            default: () => window.reconnectingTenantId ?? null,
        },
    },
    data() {
        return {
            isConnected: false,
            connecting: false,
            selectedItem: null,
        };
    },
    computed: {
        selectableTenants() {
            if (!this.reconnectingTenantId) {
                return this.xeroTenants;
            }
            return this.xeroTenants.filter((tenant) => tenant.tenantId === this.reconnectingTenantId);
        },
    },
    mounted() {
        if (this.reconnectingTenantId) {
            this.selectedItem = this.reconnectingTenantId;
        }
    },
    methods: {
        setSelected(tenant) {
            this.selectedItem = tenant;
        },
        processSelection() {
            this.connecting = true;
            axios
                .post(route('integrations.xero.processTenantSelection'), {
                    selectedTenant: this.selectedItem,
                })
                .then(() => {
                    this.completeConnection();
                    this.selectedItem = null;
                })
                .finally(() => {
                    this.connecting = false;
                });
        },
        isAlreadyConnected(tenant) {
            return !!this.alreadyConnected.find((xeroTenant) => xeroTenant == tenant.tenantId);
        },
        completeConnection() {
            this.isConnected = true;
        },
    },
};
</script>
